<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Informations de l'étudiant</h4>
            <router-link to="/liste-demande-inscriptions" 
                         class="btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              Retour
            </router-link>
          </div>

          <table class="table">
            <tbody>
              <tr v-if="demande?.numeroMatricule">
                <td>Numéro Matricule :</td>
                <td>{{ demande?.numeroMatricule }}</td>
              </tr>
              <tr v-if="demande?.nom">
                <td>Nom :</td>
                <td>{{ demande?.nom }}</td>
              </tr>
              <tr v-if="demande?.prenom">
                <td>Prénom :</td>
                <td>{{ demande?.prenom }}</td>
              </tr>
              <tr v-if="demande?.email">
                <td>Email :</td>
                <td>{{ demande?.email }}</td>
              </tr>
              <tr v-if="demande?.filiere?.libelle">
                <td>Filière :</td>
                <td>{{ demande?.filiere?.libelle }}</td>
              </tr>
             
            
            </tbody>
          </table>

         

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/services/ApiService";
import { useRoute } from "vue-router";
import { error } from "@/utils/utils";

export default defineComponent({
  name: "ViewDemandeInscription",
  setup() {
  const route = useRoute();
  const demande = ref<any>(null);
 
  const typesPieces = ref<any[]>([]);

  const getDemandeInscription = async (id: string) => {
    try {
      const { data } = await ApiService.get(`/demandes/${id}`);
      demande.value = data.data;
    } catch (err: any) {
      error(err.response?.data?.message || "Erreur lors du chargement de l'demande");
    }
  };

  onMounted(() => {
    const id = route.params.id as string;
    Promise.all([getDemandeInscription(id)]);
  });

  return { 
    demande,  
    typesPieces // Optionnel, si tu veux l'utiliser ailleurs
  };
}
});
</script>
